import { Controller } from "stimulus"
import client from '../../helpers/client'

export default class extends Controller {
  connect() {
    this.path = this.element.getAttribute('data-path')
    this.checkStatus()
  }

  checkStatus = () => {
    client.get(this.path)
      .then(response => {
        const { status, path } = response.data
        switch(status) {
          case "running":
            setTimeout(() => this.checkStatus(), 2500)
            break;
          case "complete":
            window.location.href = path
            break;
          default:
            throw new Error(`Invalid status ${status}`)
        }
      })
      .catch(e => {
        console.warn(e)
        setTimeout(() => checkStatus(), 8000)
      })
  }
}
